import { render, staticRenderFns } from "./RemoveCertificate.vue?vue&type=template&id=20450d1b"
import script from "./RemoveCertificate.vue?vue&type=script&lang=js"
export * from "./RemoveCertificate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports